import request from "../request";

export const getLevels = (curriculumId) =>
  request.get(`curriculum/${curriculumId}/level`).then((res) => res);

export const createLevel = (curriculumId, data) =>
  request.post(`curriculum/${curriculumId}/level`, data).then((res) => res);

export const updateLevel = (curriculumId, id, data) =>
  request.put(`curriculum/${curriculumId}/level/${id}`, data).then((res) => res);

export const deleteLevel = (curriculumId, id) =>
  request.delete(`curriculum/${curriculumId}/level/${id}`).then((res) => res);
